import { useEffect } from "react";
import { supabase } from "../../../integrations/supabase/client";


const App = () => {
  useEffect(() => {
    const autoLogin = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        // Try to sign in first
        const { error: signInError } = await supabase.auth.signInWithPassword({
          email: 'demo@epicreview.com',
          password: 'demo123456',
        });
        
        // If sign-in fails, create the user
        if (signInError) {
          const { error: signUpError } = await supabase.auth.signUp({
            email: 'demo@epicreview.com',
            password: 'demo123456',
          });
          
          if (signUpError) {
            console.error('Auto-signup failed:', signUpError);
          }
        }
      }
    };
    autoLogin();
  }, []);

  return (
    <div></div>
  );
};

export default App;
